import React from 'react';
import styled from 'styled-components';
import { FaLock, FaCreditCard, FaShieldAlt } from 'react-icons/fa';

const PaymentBadges = () => {
  return (
    <BadgesContainer>
      <BadgeItem>
        <IconWrapper>
          <FaLock />
        </IconWrapper>
        <BadgeText>
          <BadgeTitle>Secure SSL</BadgeTitle>
          <BadgeSubtext>256-bit Encryption</BadgeSubtext>
        </BadgeText>
      </BadgeItem>
      
      <BadgeItem>
        <IconWrapper>
          <FaShieldAlt />
        </IconWrapper>
        <BadgeText>
          <BadgeTitle>Buyer Protection</BadgeTitle>
          <BadgeSubtext>100% Guaranteed</BadgeSubtext>
        </BadgeText>
      </BadgeItem>
      
      <BadgeItem>
        <IconWrapper>
          <FaCreditCard />
        </IconWrapper>
        <BadgeText>
          <BadgeTitle>Secure Payments</BadgeTitle>
          <BadgeSubtext>Stripe & PayPal</BadgeSubtext>
        </BadgeText>
      </BadgeItem>
      
      <PaymentLogos>
        <PaymentLogo>
          <svg viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="60" height="25" rx="4" fill="#635BFF"/>
            <text x="30" y="17" fontSize="12" fill="white" textAnchor="middle" fontWeight="600">Stripe</text>
          </svg>
        </PaymentLogo>
        <PaymentLogo>
          <svg viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="60" height="25" rx="4" fill="#0070BA"/>
            <text x="30" y="17" fontSize="10" fill="white" textAnchor="middle" fontWeight="600">PayPal</text>
          </svg>
        </PaymentLogo>
        <PaymentLogo>
          <svg viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="60" height="25" rx="4" fill="#1A1F71"/>
            <text x="30" y="17" fontSize="11" fill="white" textAnchor="middle" fontWeight="600">VISA</text>
          </svg>
        </PaymentLogo>
        <PaymentLogo>
          <svg viewBox="0 0 60 25" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="60" height="25" rx="4" fill="#EB001B"/>
            <circle cx="22" cy="12.5" r="8" fill="#FF5F00"/>
            <circle cx="38" cy="12.5" r="8" fill="#F79E1B"/>
          </svg>
        </PaymentLogo>
      </PaymentLogos>
    </BadgesContainer>
  );
};

const BadgesContainer = styled.div`
  background: ${({ theme }) => theme.colors.background.card};
  border: 2px solid ${({ theme }) => theme.colors.metallic.gold};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: 2rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
  margin: 2rem 0;
`;

const BadgeItem = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  
  &:last-of-type {
    border-bottom: none;
  }
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.gradients.gold};
  border-radius: 50%;
  color: ${({ theme }) => theme.colors.primary};
  font-size: 1.5rem;
  box-shadow: ${({ theme }) => theme.shadows.gold};
`;

const BadgeText = styled.div`
  flex: 1;
`;

const BadgeTitle = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.dark};
  margin-bottom: 0.25rem;
`;

const BadgeSubtext = styled.div`
  font-size: 0.85rem;
  color: ${({ theme }) => theme.colors.text.muted};
`;

const PaymentLogos = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 2px solid ${({ theme }) => theme.colors.metallic.gold};
  flex-wrap: wrap;
`;

const PaymentLogo = styled.div`
  width: 60px;
  height: 25px;
  transition: transform ${({ theme }) => theme.transitions.fast};
  
  &:hover {
    transform: scale(1.1);
  }
  
  svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  }
`;

export default PaymentBadges;
